import { createSelector } from 'reselect';
import { selectIsShowing } from 'root/selectors';

const getCameraData = (state) => state.camera;

const selectTabData = createSelector(selectIsShowing, getCameraData, (isWidgetShowing, data) => ({
  isAllowed: data.cameraAllowed,
  isLoading: data.cameraLoading,
  notFound: data.cameraNotFound,
  isWidgetShowing,
}));

export { selectTabData };
